var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassrankedLogoMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.017 17.0602C13.8531 17.0602 15.3479 15.5429 15.3479 13.6792C15.3479 11.8155 13.8531 10.2982 12.017 10.2982C10.1809 10.2982 8.68616 11.8155 8.68616 13.6792C8.68616 15.5549 10.1809 17.0602 12.017 17.0602Z",
    fill: "#1F5EEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33086 7.29954C5.16696 7.29954 6.66173 5.78229 6.66173 3.91857C6.66173 2.05485 5.16696 0.537598 3.33086 0.537598C1.49477 0.537598 0 2.05485 0 3.91857C0 5.78229 1.49477 7.29954 3.33086 7.29954Z",
    fill: "#1F5EEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9581 18.0518C10.2162 18.0518 8.80383 19.4854 8.80383 21.2535V23.3203C8.80383 25.0765 10.2044 26.4863 11.9228 26.4863H15.1242V21.2655C15.1242 19.4854 13.7119 18.0518 11.9581 18.0518Z",
    fill: "#1F5EEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43808 26.5221V11.4929C6.43808 9.72478 5.0257 8.29115 3.28376 8.29115C1.53006 8.2792 0.117676 9.71283 0.117676 11.4929V21.3611C0.117676 24.2164 2.38925 26.5221 5.19047 26.5221H6.43808Z",
    fill: "#1F5EEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8937 0.537598H9.78075C9.16872 0.537598 8.68616 1.03937 8.68616 1.64866V5.84202C8.68616 6.46326 9.18049 6.95308 9.78075 6.95308H25.8937C26.5057 6.95308 26.9882 6.45131 26.9882 5.84202V1.64866C26.9882 1.03937 26.4939 0.537598 25.8937 0.537598Z",
    fill: "#5D90F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9055 10.3102H18.1256C17.5136 10.3102 17.031 10.812 17.031 11.4212V15.6146C17.031 16.2358 17.5253 16.7257 18.1256 16.7257H25.9055C26.5175 16.7257 27.0001 16.2239 27.0001 15.6146V11.4212C27.0001 10.812 26.5057 10.3102 25.9055 10.3102Z",
    fill: "#5D90F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9055 20.0827H18.1256C17.5136 20.0827 17.031 20.5845 17.031 21.1938V25.3871C17.031 26.0084 17.5253 26.4982 18.1256 26.4982H25.9055C26.5175 26.4982 27.0001 25.9964 27.0001 25.3871V21.1938C27.0001 20.5725 26.5057 20.0827 25.9055 20.0827Z",
    fill: "#5D90F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassrankedLogoMob);
export default __webpack_public_path__ + "static/media/classrankedLogo_Mob.5c2d4cf1bcb18827ec2ee9a18142bdac.svg";
export { ForwardRef as ReactComponent };